import Controller from '@ember/controller';
import { sort } from '@ember/object/computed';

export default class CommunicationsByContactController extends Controller {
  headerBarLinks = [
    {
      route: 'funds.fund.communications.index',
      models: [],
      label: 'All',
    },
    {
      route: 'funds.fund.communications.by-contact',
      models: [],
      label: 'By Contact',
    },
  ];

  sortBy = ['completedAt:desc'];
  @sort('model', 'sortBy') sortedCommunications;
}
